// extracted by mini-css-extract-plugin
export default {"fieldset":"fieldset_fieldset__MUq16","legend":"fieldset_legend__TsZQV"};